<script>
    import { createEventDispatcher } from 'svelte';
    import Avatar from '../../../images/Avatar/v1/Avatar.svelte';

    const dispatch = createEventDispatcher();

    /**
     * @type {string}
     */
    export let src = '';

    /**
     * @type {string}
     */
    export let avatarAlternativeText = '';

    /**
     * @type {number}
     */
    export let size = 300;

    /**
     * @type {string}
     */
    export let name = '';

    /**
     * @type {(string|undefined)}
     */
    export let role = undefined;

    /**
     * @type {'non-interactive'|'link'|'button'}
     */
    export let type = 'non-interactive';

    /**
     * @type {string}
     */
    export let linkUrl = null;

    function onClick() {
        dispatch('click');
    }

    if (!linkUrl && type === 'link') {
        console.warn('URL for the link is missing.');
    }
</script>

<div class="prom-profile">
    {#if type === 'button'}
        <button class="prom-profile__wrapper prom-profile__button" on:click={onClick}>
            <Avatar {size} {src} alternativeText={avatarAlternativeText} />
            <div class="prom-profile__text">
                <span class="prom-profile__name">{name}</span>
                {#if role}
                    <span class="prom-profile__role">{role}</span>
                {/if}
            </div>
        </button>
    {:else if type === 'link'}
        <div class="prom-profile__wrapper prom-profile__link">
            <Avatar {size} {src} alternativeText={avatarAlternativeText} />
            <a class="prom-profile__link-text prom-profile__text" href={linkUrl}>
                <span class="prom-profile__name">{name}</span>
                {#if role}
                    <span class="prom-profile__role">{role}</span>
                {/if}
            </a>
        </div>
    {:else}
        <div class="prom-profile__wrapper">
            <Avatar {size} {src} alternativeText={avatarAlternativeText} />
            <div class="prom-profile__text">
                <span class="prom-profile__name">{name}</span>
                {#if role}
                    <span class="prom-profile__role">{role}</span>
                {/if}
            </div>
        </div>
    {/if}
</div>
